import { getInfo, logout, getOrganizationsByUserId } from '@/api/user'

const state = {
  name: '',
  userName: '',
  avatar: '',
  email: '',
  phoneNumber: '',
  roles: [],
  author: false,
  authoraddress: '',
  avatarId: '',
  id: '',
  orgins: [],
  ApplicantApproval: false,
  ApplicantUser: false,
  UpjobNo: false,
  flag: '',
  backend:null,
  auth:null,
  language:'',
}

const mutations = {
  SET_Auth: (state, auth) => {
    state.auth = auth;
  },
  SET_Language: (state, language) => {
    state.language = language;
  },
  SET_Id: (state, id) => {
    state.id = id;
  },
  SET_BackEnd:(state,backend)=>{
    state.backend = backend;
  },
  SET_AUTHORADDRESS: (state, address) => {
    state.authoraddress = address
  },
  SET_AUTHOR: (state, author) => {
    state.author = author;
  },
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  SET_NAME: (state, name) => {
    state.name = name
  },
  SET_USERNAME: (state, userName) => {
    state.userName = userName
  },
  SET_TEL: (state, phoneNumber) => {
    state.phoneNumber = phoneNumber
  },
  SET_AVATARID: (state, AVATARID) => {
    state.avatarId = AVATARID
  },
  SET_ROLES: (state, roles) => {
    state.roles = roles
  },
  SET_EMAIL: (state, avatar) => {
    state.email = avatar
  },
  SET_Orgins: (state, orgins) => {
    state.orgins = orgins
  },
  SET_ApplicantUser: (state, ApplicantUser) => {
    state.ApplicantUser = ApplicantUser
  },
  SET_ApplicantApproval: (state, ApplicantApproval) => {
    state.ApplicantApproval = ApplicantApproval
  },
  SET_UpjobNo: (state, UpjobNo) => {
    state.UpjobNo = UpjobNo
  },
  CLEAN: state => {
    state.token = ''
    state.name = ''
    state.userName = ''
    state.avatar = ''
    state.email = ''
    state.phoneNumber = ''
    state.roles = []
    state.avatarId = ''
    state.id = ''
    state.orgins = [],
    state.ApplicantApproval = false,
    state.ApplicantUser = false,
    state.UpjobNo = false,
    state.backend = null,
    state.auth=null,
    state.language=''
  },
  CLEAN_AUTHOR: state => {
    state.author = false
  },
  SET_FLAG: (state, flag) => {
    state.flag = flag;
  }
}

const actions = {

  setLanguage: ({ commit }, language) => {
    commit('SET_Language', language);
  },
  setAuth ({ commit }, auth) {
    commit('SET_Auth', auth);
  },
  setId ({ commit }, id) {
    commit('SET_Id', id);
  },
  setFlag ({ commit }, flag) {
    commit('SET_FLAG', flag);
  },
  // get user info
  getInfo ({ commit }) {
    return new Promise((resolve, reject) => {
      getInfo()
        .then(async response => {
          if (!response) {
            reject('Verification failed, please Login again.')
          }
          console.log(response, '4444')
          const { userName, name, phoneNumber, email } = response
          commit('SET_NAME', name)
          commit('SET_USERNAME', userName)
          commit('SET_TEL', phoneNumber)
          commit('SET_EMAIL', email)
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  logout ({ commit }) {
    return new Promise((resolve, reject) => {
      logout()
        .then(() => {
          commit('CLEAN')
          resolve()
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  getOrgin ({ commit }) {
    return new Promise((resolve) => {
      getOrganizationsByUserId(state.id).then(
        res => {
          commit('SET_Orgins', res.items);
          resolve();
        })
    })
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
